var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.imgClass,attrs:{"src":_vm.resolvedSrc,"alt":_vm.alt,"height":_vm.height},on:{"error":_vm.onError,"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }